// npm
import React from 'react'

// react-konva
import {Line, Rect, Ellipse, Arrow, Text} from 'react-konva'

// constants
import {DEFAULT_STROKE, DEFAULT_STROKE_WIDTH, DEFAULT_FONT_SIZE, LABEL_FONT_FAMILY, LABEL_LINE_HEIGHT, TOOLS} from './constants'


// renders one persisted shape as the matching Konva node. Every shape carries the same generic
// positioning props (x, y, rotation, scaleX, scaleY) alongside its own geometry (points / width+
// height / radiusX+radiusY / text) - Konva composes the two automatically, so dragging or
// transforming a shape (see drawing-canvas.jsx's handleShapeChange) only ever needs to update
// those generic props, regardless of shape type.
const ShapeRenderer = ({shape, interactive, onSelect, onChange, onEdit, shapeRef}) => {
	const common = {
		id: shape.id,
		ref: shapeRef,
		x: shape.x || 0,
		y: shape.y || 0,
		rotation: shape.rotation || 0,
		scaleX: shape.scaleX || 1,
		scaleY: shape.scaleY || 1,
		stroke: shape.stroke || DEFAULT_STROKE,
		strokeWidth: shape.strokeWidth || DEFAULT_STROKE_WIDTH,
		draggable: interactive,
		onClick: interactive ? onSelect : undefined,
		onTap: interactive ? onSelect : undefined,
		onDragEnd: interactive ? onChange : undefined,
		onTransformEnd: interactive ? onChange : undefined
	};

	switch (shape.type) {
		case TOOLS.PEN:
		case TOOLS.LINE:
			return (
				<Line
					{...common}
					points={shape.points}
					lineCap="round"
					lineJoin="round"
					tension={shape.type === TOOLS.PEN ? 0.4 : 0}
				/>
			);

		case TOOLS.ARROW:
			return (
				<Arrow
					{...common}
					points={shape.points}
					fill={shape.stroke || DEFAULT_STROKE}
					pointerLength={10}
					pointerWidth={10}
				/>
			);

		case TOOLS.RECT:
			return (
				<Rect
					{...common}
					width={shape.width}
					height={shape.height}
				/>
			);

		case TOOLS.DIAMOND: {
			const {width, height} = shape;
			const points = [width / 2, 0, width, height / 2, width / 2, height, 0, height / 2];
			return (
				<Line
					{...common}
					points={points}
					closed
				/>
			);
		}

		case TOOLS.CIRCLE:
			return (
				<Ellipse
					{...common}
					radiusX={shape.radiusX}
					radiusY={shape.radiusY}
				/>
			);

		case TOOLS.TEXT:
			return (
				<Text
					{...common}
					text={shape.text}
					fontSize={shape.fontSize || DEFAULT_FONT_SIZE}
					fontFamily={LABEL_FONT_FAMILY}
					lineHeight={LABEL_LINE_HEIGHT}
					onDblClick={onEdit}
					onDblTap={onEdit}
					fill={shape.stroke || DEFAULT_STROKE}
					stroke={null}
					strokeWidth={0}
				/>
			);

		default:
			return null;
	}
};

export {ShapeRenderer}
